(function(){
var _$settings_3 = {};
"use strict";

Object.defineProperty(_$settings_3, "__esModule", { value: true });
_$settings_3.settings = void 0;
_$settings_3.settings = {
    project: 'WTW.EX.Assets',
    version: '1.0.0',
    author: 'Willis Towers Watson',
    company: 'Willis Towers Watson',
    url: 'www.willistowerswatson.com',
    email: 'appx@willistowerswatson.com',
    description: 'WTW.EX.Assets contains the resource files needed for pre-auth and some post-auth user interfaces and user experiences',
    FALLBACK_LANGUAGE: 'en-US',
    legalDocs: {
        basePath: '/docs',
        fileNames: {
            termsOfUse: 'terms-of-use.html',
            cookieNotice: 'cookie-notice.html',
            privacyNotice: 'privacy-notice.html'
        }
    },
    cookieConfigs: {
        commonAuth: {
            domain: 'auth-2.ehr.com',
            appId: 'c881b241-6f27-47c9-b147-f6d7c93e8e6d'
        },
        registration: {
            domain: 'signin-embark.ehr.com',
            appId: '56da48b8-c13b-495e-bdd0-0e87fafc26c9'
        },
        portal: {
            domain: 'embark.ehr.com',
            appId: '732a960c-ec94-4992-ab25-085d34ac38f8'
        }
    },
    logos: {
        helpicon: '/img/icons8-help.svg',
        footer: '/img/wtw_logo_blk.svg',
        header: {
            demoClientLogoPath: '/img/myPortal.png',
            wtwLogoPath: '/img/wtw_logo_purple.svg'
        }
    },
    toastTimeout: 5000
};

var _$environmentDefault_1 = {};
"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(_$environmentDefault_1, "__esModule", { value: true });
_$environmentDefault_1.environment = void 0;
var lodash_merge_1 = __importDefault(require("lodash.merge"));
/* removed: var _$settings_3 = require("./settings"); */;
_$environmentDefault_1.environment = (0, lodash_merge_1.default)({}, _$settings_3.settings, {
    copyrightCorporateName: "WTW",
    defaultCultureCode: "en-us",
    registrationConfigApiUrl: "",
    storageAccountUrl: '',
    storageContainer: '',
    logos: {
        helpicon: "/img/icons8-help.svg",
        footer: "/img/wtw_logo_blk.svg",
        header: {
            demoClientLogoPath: "/img/myPortal.png",
            wtwLogoPath: "/img/wtw_logo_purple.svg"
        },
        alt: 'WTW Logo'
    },
    translationApiUrl: "",
    jiraProxyAPI: "",
    translation: {
        apiUrl: "",
        applicationContextId: 2
    },
    appInsightsConfig: {
        applicationName: 'WTW.EX.Assets',
        version: '1.0.8',
        instrumentationKey: '',
        environmentName: ''
    },
    appInsightsConfigPro: {
        applicationName: 'WTW.EX.Assets',
        version: '1.0.8',
        instrumentationKey: '',
        environmentName: ''
    },
    topLevelDomain: "",
    possibleClientCountryParams: ["clientCountry", "clientCountryId"],
    possibleLanguageParams: ["cultureCode", "ui_locales"],
    legalDoc: {
        urlBase: "/notices",
        fileNames: {
            termsOfUse: "terms-of-use",
            cookieNotice: "cookie-notice",
            privacyNotice: "privacy-notice"
        }
    },
    useTestScripts: true,
    cookieAppIds: {},
    prodDomain: 'ehr.com',
    portalSiteName: 'appx',
    oneTrust: {
        cookieBannerScriptSrc: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        defaultLanguage: "en"
    },
    registrationPageUrl: "",
    embarkPrivacyNoticePageUrl: "",
    policyNames: {
        B2C_1A_PEX_ChangeMFA: "B2C_1A_PEX_ChangeMFA",
        B2C_1A_PEX_ChangePassword: 'B2C_1A_PEX_ChangePassword',
        B2C_1A_PEX_ChangePhoneNumber: 'B2C_1A_PEX_ChangePhoneNumber',
        B2C_1A_PEX_ChangeSignInName: 'B2C_1A_PEX_ChangeSignInName',
        B2C_1A_PEX_CorpEmail_SignUp: 'B2C_1A_PEX_CorpEmail_SignUp',
        B2C_1A_PEX_ForgotPassword: 'B2C_1A_PEX_ForgotPassword',
        B2C_1A_PEX_SelfIdentification: "B2C_1A_PEX_SelfIdentification",
        B2C_1A_PEX_Signin: 'B2C_1A_PEX_Signin',
        B2C_1A_PEX_SignUp: 'B2C_1A_PEX_SignUp',
        B2C_1A_PEX_SignUpSignIn: "B2C_1A_PEX_SignUpSignIn",
        B2C_1A_PEX_SigninOidc: "B2C_1A_PEX_SigninOidc",
        B2C_1A_SSO_Assertion: 'B2C_1A_WTW_CommonAuthentication',
        B2C_1A_PEX_SignIn2: 'B2C_1A_PEX_SignIn2',
        B2C_1A_PEX_SignUp2: 'B2C_1A_PEX_SignUp2',
        B2C_1A_PEX_ChangeMFABETA: "B2C_1A_PEX_ChangeMFABETA",
        B2C_1A_PEX_ChangePasswordBETA: 'B2C_1A_PEX_ChangePasswordBETA',
        B2C_1A_PEX_ChangePhoneNumberBETA: 'B2C_1A_PEX_ChangePhoneNumberBETA',
        B2C_1A_PEX_ChangeSignInNameBETA: 'B2C_1A_PEX_ChangeSignInNameBETA',
        B2C_1A_PEX_CorpEmail_SignUpBETA: 'B2C_1A_PEX_CorpEmail_SignUpBETA',
        B2C_1A_PEX_ForgotPasswordBETA: 'B2C_1A_PEX_ForgotPasswordBETA',
        B2C_1A_PEX_SelfIdentificationBETA: "B2C_1A_PEX_SelfIdentificationBETA",
        B2C_1A_PEX_SigninBETA: 'B2C_1A_PEX_SigninBETA',
        B2C_1A_PEX_SignUpBETA: 'B2C_1A_PEX_SignUpBETA',
        B2C_1A_PEX_SignUpSignInBETA: "B2C_1A_PEX_SignUpSignInBETA"
    },
    cookieBannerSettings: {
        verboseLogging: false,
        oneTrustCheckerIntervalInSeconds: 5
    },
    samlUrl: "https://n21pexsamltestqaappsvc.azurewebsites.net",
    pushNotificationsApiUrl: "https://embarkpro-qa.ehr.com/std-gateway/api/pushnotifications"
});

var _$environment_2 = {};
"use strict";

var ____importDefault_2 = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(_$environment_2, "__esModule", { value: true });
_$environment_2.environment = void 0;
var __lodash_merge_1_2 = ____importDefault_2(require("lodash.merge"));
/* removed: var _$environmentDefault_1 = require("./environment.default"); */;
_$environment_2.environment = (0, __lodash_merge_1_2.default)({}, _$environmentDefault_1.environment, {
    environmentName: "uat",
    storageAccountUrl: 'https://assets-embark-uat.ehr.com',
    storageContainer: '',
    registrationConfigApiUrl: 'https://embarkpro-uatna.ehr.com/std-gateway/api/registrationConfig',
    translationApiUrl: 'https://embark-uat-gw.ehr.com/api/Registration/Translation',
    jiraProxyAPI: 'https://embarkpro-uatna.ehr.com/std-gateway/api/jira',
    registrationApi: "https://embark-uat-gw.ehr.com/api/Registration",
    configurationApiUrl: "https://embarkpro-uatna.ehr.com/std-gateway/api/config",
    signUpUrl: {
        signUpBaseUrl: "https://signin-embark-uat.ehr.com",
        redirectUrl: "https://auth-2-uat.ehr.com/wtwb2cuateu.onmicrosoft.com/oauth2/authresp"
    },
    translation: {
        apiUrl: "https://translations-service-uat.willistowerswatson.com/api",
        applicationContextId: 2
    },
    appInsightsConfig: {
        instrumentationKey: '62341ccf-0f1f-40e1-a66e-660181d3fb61',
        environmentName: 'uat'
    },
    appInsightsConfigPro: {
        instrumentationKey: '66d2060f-a371-427e-89b2-2771d2547a03',
        environmentName: 'AzUATEM'
    },
    useTestScripts: true,
    cookieAppIds: {
        commonAuth: 'e5277f8a-ac5a-4cc7-b6ac-dd4bacd52049',
        registration: 'e5277f8a-ac5a-4cc7-b6ac-dd4bacd52049',
        portal: '79f3ee7c-787e-4121-9c05-b35b99548c92'
    },
    topLevelDomain: "ehr.com",
    portalSiteName: 'embark',
    registrationPageUrl: "https://signin-embark-uat.ehr.com",
    embarkPrivacyNoticePageUrl: "https://signin-embark-uat.ehr.com/notices/privacy-notice",
    policyNames: {
        B2C_1A_PEX_ChangePassword: 'B2C_1A_PEX_ChangePassword',
        B2C_1A_PEX_ChangePhoneNumber: 'B2C_1A_PEX_ChangePhoneNumber',
        B2C_1A_PEX_ChangeSignInName: 'B2C_1A_PEX_ChangeSignInName',
        B2C_1A_PEX_CorpEmail_SignUp: 'B2C_1A_PEX_CorpEmail_SignUp',
        B2C_1A_PEX_ForgotPassword: 'B2C_1A_PEX_ForgotPassword',
        B2C_1A_PEX_Signin: 'B2C_1A_PEX_Signin',
        B2C_1A_PEX_SignUp: 'B2C_1A_PEX_SignUp',
        B2C_1A_SSO_Assertion: 'B2C_1A_WTW_CommonAuthentication',
        B2C_1A_PEX_SignUpSignInBeta: "B2C_1A_PEX_SignUpSignInBETA",
        B2C_1A_PEX_SelfIdentification: "B2C_1A_PEX_SelfIdentification",
        B2C_1A_PEX_SigninOidc: "B2C_1A_PEX_SigninOidc",
        B2C_1A_PEX_ChangeMFA: "B2C_1A_PEX_ChangeMFA",
        B2C_1A_PEX_SignIn2: 'B2C_1A_PEX_SignIn2',
        B2C_1A_PEX_SignUp2: 'B2C_1A_PEX_SignUp2',
        B2C_1A_PEX_SignUpSignIn: 'B2C_1A_PEX_SignUpSignIn'
    },
    cookieBannerSettings: {
        verboseLogging: false,
        oneTrustCheckerIntervalInSeconds: 5
    },
    samlUrl: "https://n21pexsamltestuatappsvc.azurewebsites.net",
    pushNotificationsApiUrl: "https://embarkpro-uatna.ehr.com/std-gateway/api/pushnotifications",
    loginUrl: "https://signin-embark-uat.ehr.com/login",
    EnabledSessionTranslation: false,
    SessionTranslationKey: 'SA_TranslationKey_',
    SessionTranslationTimeOut: 15
});

var _$domainEnum_5 = {};
"use strict";

Object.defineProperty(_$domainEnum_5, "__esModule", { value: true });
_$domainEnum_5.Domain = void 0;
var Domain;
(function (Domain) {
    Domain[Domain["Registration"] = 0] = "Registration";
    Domain[Domain["Main"] = 1] = "Main";
    Domain[Domain["B2C"] = 2] = "B2C";
    Domain[Domain["Embark2"] = 3] = "Embark2";
})(Domain = _$domainEnum_5.Domain || (_$domainEnum_5.Domain = {}));

var _$commonHelper_6 = {};
"use strict";

var ____importDefault_6 = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(_$commonHelper_6, "__esModule", { value: true });
_$commonHelper_6.validateEmail = _$commonHelper_6.waitUntilTrue = _$commonHelper_6.caseInsensitiveArrayIncludes = _$commonHelper_6.caseInsensitiveStringCompare = _$commonHelper_6.getCurrentDomain = _$commonHelper_6.getDeviceType = _$commonHelper_6.extractEmailInString = _$commonHelper_6.setNewUrlQueryParam = _$commonHelper_6.getQueryParam = _$commonHelper_6.windowSettings = _$commonHelper_6.getCultureInfoFromPage = _$commonHelper_6.waitForElementToLoad = _$commonHelper_6.stringToEnumValue = _$commonHelper_6.inIframe = _$commonHelper_6.loadPolyfillsIfNeeded = _$commonHelper_6.loadScript = void 0;
var device_detector_js_1 = ____importDefault_6(require("device-detector-js"));
/* removed: var _$environment_2 = require("../../environments/environment"); */;
/* removed: var _$domainEnum_5 = require("../enums/domain.enum"); */;
var loadScript = function loadScript(src, doneCallback) {
    if (doneCallback === void 0) {
        doneCallback = null;
    }
    if (!!!doneCallback) doneCallback = function doneCallback() {};
    if (isTheScriptAlreadyLoaded(src)) {
        doneCallback();
        return;
    }
    var js = document.createElement("script");
    js.src = src;
    js.onload = function () {
        addScriptToLoadedScripts(src);
        doneCallback();
    };
    js.onerror = function () {
        doneCallback(new Error("Failed to load script " + src));
    };
    document.head.appendChild(js);
};
_$commonHelper_6.loadScript = loadScript;
var loadPolyfillsIfNeeded = function loadPolyfillsIfNeeded(doneCallback) {
    if (!!!window.fetch || !!!window.Promise) {
        var polyfillPackageUrl = "".concat(_$environment_2.environment.storageAccountUrl).concat(_$environment_2.environment.storageContainer, "/js/polyfills.js");
        (0, _$commonHelper_6.loadScript)(polyfillPackageUrl, function () {
            doneCallback();
        });
    } else {
        doneCallback();
    }
};
_$commonHelper_6.loadPolyfillsIfNeeded = loadPolyfillsIfNeeded;
var inIframe = function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
_$commonHelper_6.inIframe = inIframe;
var addScriptToLoadedScripts = function addScriptToLoadedScripts(src) {
    window.loadedScripts = (window.loadedScripts || []).concat(src.toLocaleLowerCase());
};
var isTheScriptAlreadyLoaded = function isTheScriptAlreadyLoaded(src) {
    return (window.loadedScripts || []).indexOf(src.toLocaleLowerCase()) > -1;
};
var stringToEnumValue = function stringToEnumValue(enumObj, value) {
    var enumKey = Object.keys(enumObj).filter(function (k) {
        return enumObj[k].toString() === value;
    })[0];
    return enumObj[enumKey];
};
_$commonHelper_6.stringToEnumValue = stringToEnumValue;
var waitForElementToLoad = function waitForElementToLoad(elementSelector, loadDoneCallback) {
    var retryMsDelay = 100;
    var retryCount = 100;
    var retries = 0;
    var interval = setInterval(function () {
        retries++;
        if ($(elementSelector).length > 0) {
            var el = $(elementSelector);
            clearInterval(interval);
            console.debug("".concat(elementSelector, " found after ").concat(retries, " retries!"));
            loadDoneCallback(el);
        }
        if (retries === retryCount) {
            console.warn("".concat(elementSelector, " not found after ").concat(retries, " retries..."));
            clearInterval(interval);
        }
    }, retryMsDelay);
};
_$commonHelper_6.waitForElementToLoad = waitForElementToLoad;
var getCultureInfoFromPage = function getCultureInfoFromPage() {
    var cultureCode = "";
    var language = "en";
    var country = "us";
    if (window && window.SETTINGS) {
        if (window.SETTINGS.locale.lang) {
            if (window.SETTINGS.locale.country) {
                language = window.SETTINGS.locale.lang.toLowerCase();
                country = window.SETTINGS.locale.country.toLowerCase();
                cultureCode = "".concat(language, "-").concat(country);
            } else {
                language = window.SETTINGS.locale.lang.toLowerCase();
                cultureCode = sessionStorage.getItem('cultureCode');
                console.debug("scripts > translationservice.js > langCode: ", cultureCode);
            }
        }
    }
    return { cultureCode: cultureCode, language: language, country: country };
};
_$commonHelper_6.getCultureInfoFromPage = getCultureInfoFromPage;
var windowSettings = function windowSettings() {
    var _a;return (_a = window && window["SETTINGS"]) !== null && _a !== void 0 ? _a : {};
};
_$commonHelper_6.windowSettings = windowSettings;
var getQueryParam = function getQueryParam(name, url) {
    if (url === void 0) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"), "i"),
        results = regex.exec(url);
    if (!results || !results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
_$commonHelper_6.getQueryParam = getQueryParam;
var setNewUrlQueryParam = function setNewUrlQueryParam(queryparam, newvalue, currentUrl) {
    if (currentUrl === void 0) {
        currentUrl = window.location.href;
    }
    var url = new URL(currentUrl);
    url.searchParams.set(queryparam, newvalue);
    return url.href;
};
_$commonHelper_6.setNewUrlQueryParam = setNewUrlQueryParam;
var extractEmailInString = function extractEmailInString(s) {
    if (!s) return [];
    var emailRegex = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;
    return s.match(emailRegex);
};
_$commonHelper_6.extractEmailInString = extractEmailInString;
var deviceType;
var getDeviceType = function getDeviceType() {
    if (deviceType) return deviceType;
    var userAgent = navigator.userAgent;
    var deviceInfo = new device_detector_js_1.default().parse(userAgent);
    console.debug("[common.helper::getDeviceType] deviceInfo", deviceInfo);
    var type;
    switch (deviceInfo.device.type.toString()) {
        case "desktop":
            type = "Desktop";
            break;
        case "smartphone":
            type = "Mobile";
            break;
        case "tablet":
            type = "Tablet";
            break;
        case "phablet":
            type = "Phablet";
            break;
        case "":
            switch (true) {
                case /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent):
                    type = "Mobile";
                    break;
                case /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent.toLowerCase()):
                    type = "Tablet";
                    break;
                default:
                    type = "Others";
                    break;
            }
            break;
        default:
            type = "Others";
    }
    console.debug("[common.helper::getDeviceType] type", type);
    return deviceType = type;
};
_$commonHelper_6.getDeviceType = getDeviceType;
var currentDomain;
var getCurrentDomain = function getCurrentDomain() {
    if (currentDomain) return currentDomain;
    var domain;
    switch (true) {
        case !!window["SETTINGS"]:
            domain = _$domainEnum_5.Domain.B2C;
            break;
        case !!window["SharedComponentsWidget"]:
            domain = _$domainEnum_5.Domain.Main;
            break;
        case !!window["Domain"] && window["Domain"] === "Registration":
            domain = _$domainEnum_5.Domain.Registration;
            break;
        default:
            domain = _$domainEnum_5.Domain.Embark2;
    }
    return currentDomain = domain;
};
_$commonHelper_6.getCurrentDomain = getCurrentDomain;
var caseInsensitiveStringCompare = function caseInsensitiveStringCompare(s1, s2) {
    var _a, _b;
    return ((_a = s1 === null || s1 === void 0 ? void 0 : s1.toLocaleUpperCase()) !== null && _a !== void 0 ? _a : "") === ((_b = s2 === null || s2 === void 0 ? void 0 : s2.toLocaleUpperCase()) !== null && _b !== void 0 ? _b : "");
};
_$commonHelper_6.caseInsensitiveStringCompare = caseInsensitiveStringCompare;
var caseInsensitiveArrayIncludes = function caseInsensitiveArrayIncludes(arr, s) {
    var _a, _b;
    s = (_a = s === null || s === void 0 ? void 0 : s.toLocaleUpperCase()) !== null && _a !== void 0 ? _a : "";
    return (_b = arr === null || arr === void 0 ? void 0 : arr.some(function (x) {
        return x.toLocaleUpperCase() === s;
    })) !== null && _b !== void 0 ? _b : false;
};
_$commonHelper_6.caseInsensitiveArrayIncludes = caseInsensitiveArrayIncludes;
var waitUntilTrue = function waitUntilTrue(conditionCallback, callback) {
    var retryMsDelay = 100;
    var retryCount = 60;
    var retries = 0;
    var interval = setInterval(function () {
        retries++;
        if (!!conditionCallback()) {
            clearInterval(interval);
            console.debug("[CommonHelper:waitUntilTrue] conditionCallback passed after ".concat(retries, " retries!"));
            callback();
        }
        if (retries === retryCount) {
            console.debug("[CommonHelper:waitUntilTrue] conditionCallback didn't pass after ".concat(retries, " retries..."));
            clearInterval(interval);
        }
    }, retryMsDelay);
};
_$commonHelper_6.waitUntilTrue = waitUntilTrue;
var validateEmail = function validateEmail(email) {
    var emailReg = /^([\w-\.]+)@@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return emailReg.test(email);
};
_$commonHelper_6.validateEmail = validateEmail;

var _$bundle_4 = {};
"use strict";

Object.defineProperty(_$bundle_4, "__esModule", { value: true });
/* removed: var _$environment_2 = require("../../../../environments/environment"); */;
/* removed: var _$commonHelper_6 = require("../../../helpers/common.helper"); */;
(0, _$commonHelper_6.loadPolyfillsIfNeeded)(function () {
    var commonComponentUrl = "".concat(_$environment_2.environment.storageAccountUrl).concat(_$environment_2.environment.storageContainer, "/js/common-components.js");
    (0, _$commonHelper_6.loadScript)(commonComponentUrl);
});

}());